'use strict';

import React from 'react';

import classNames from 'classnames';

import 'styles/Tag.scss';

class Tag extends React.Component {
    
    render() {

        var classes = classNames(
            'ess-tag', this.props.className, {
                'tag-plain': this.props.plain,
                'pad-left': this.props.padLeft,
            }
        );

        return (
            <span id={this.props.id} className={classes}>
                {this.props.label}
            </span>
        );
    }
}

export default Tag; 